/**
 *  Component: Installation Section
 */
import React from 'react';

import { StyledTypography } from 'styles/common';

import { Download1Icon } from 'constants/icons';

import { BodyContainer, FormContainer, FormHeading, Separator, Icon } from '../styles';

const InstallationSection = () => (
  <FormContainer>
    <FormHeading>
      <Icon>
        <Download1Icon size="fixed16px" />
      </Icon>
      Installation Steps
    </FormHeading>
    <Separator />
    <BodyContainer>
      <StyledTypography color="#333" bottomGutter={1} topGutter={1}>
        1. Click on "Add to Slack" button above
      </StyledTypography>
      <StyledTypography color="#333" bottomGutter={1}>
        2. Login to your Slack website & click on "Allow"
      </StyledTypography>
      <StyledTypography color="#333">
        3. Choose Mesh notifications that you want to receive on Slack, below
      </StyledTypography>
    </BodyContainer>
  </FormContainer>
);

export default InstallationSection;
